export default __webpack_public_path__ + "static/media/est-pampulha.e7943546.png";